import useResources from "./use-resources";
import useTenants from "./use-tenants";
import useProfileFilter from "./use-profile-filter";
import moment from "moment/moment";

export default function useBalancesDashboard(options = {}) {
  const { groupBy } = options;
  const {
    resources: balancesDashboard,
    groupedResources: groupedBalancesDashboard,
    error,
    isLoading,
  } = useResources("balance_tenants/balance_dashboard", {}, { groupBy });
  const { isFilterActive } = useProfileFilter();
  const { tenants: filteredTenants } = useTenants();

  const debutMois = moment().startOf("month");
  const duMois = (balance) => moment(balance.date_transac) >= debutMois;
  let revenusMois = 0;
  let appelesMois = 0;

  // Les totaux du mois suivent le filtre bailleur, comme les biens et les locataires.
  const filteredTenantIds = new Set(filteredTenants.map((tenant) => tenant.id));
  const balancesDuFiltre = isFilterActive
    ? balancesDashboard.filter((tenant) =>
        filteredTenantIds.has(tenant.id_tenant),
      )
    : balancesDashboard;

  for (let tenant of balancesDuFiltre) {
    for (let payment of tenant.last_payments.filter(duMois)) {
      revenusMois += payment.montant;
    }
    // Les appels sont saisis en négatif (dû du locataire), un avoir en positif.
    for (let call of (tenant.last_calls ?? []).filter(duMois)) {
      appelesMois -= call.montant;
    }
  }

  return {
    balancesDashboard,
    groupedBalancesDashboard,
    revenusMois,
    appelesMois,
    error,
    isLoading,
  };
}
